
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/blog",
      function () {
        return require("private-next-pages/[locale]/blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/blog"])
      });
    }
  